const breadCrumb = "Diário Digital - Objetos de Conhecimento";

const routes = [
  {
    path: "/objetos-conhecimento",
    name: "objetos-conhecimento",
    meta: {
      allowedPermissions: ["objeto_conhecimento_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/ObjetosConhecimento/ObjetosConhecimentoHome.vue"
      ),
  },
  {
    path: "/objetos-conhecimento/novo",
    name: "objetos-conhecimento-novo",
    meta: {
      allowedPermissions: ["objeto_conhecimento_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/ObjetosConhecimento/ObjetosConhecimentoCad.vue"
      ),
  },
  {
    path: "/objetos-conhecimento/editar/:id",
    name: "objetos-conhecimento-editar",
    meta: {
      allowedPermissions: ["objeto_conhecimento_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ParametrosDiario/ObjetosConhecimento/ObjetosConhecimentoEdit.vue"
      ),
  },
];

export default routes;
